import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import dayjs from "dayjs";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import {
  getActivityDate,
  ACTIVITY_QR_KEY,
  encryptActivitySignup,
} from "../../services/ActivityService";
import { getQrBaseUrl } from "../../services/QrService";
import { Alert } from "@mui/material";

const ActivitySignupAttendQr = () => {
  const { eid } = useParams();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_activityDate, setActivityDate] = useState({
    eid: "",
    name: "",
    date: "",
    period: "",
    periodName: "",
    last_name: "",
    first_name: "",
    locationName: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [getActivityDate(_school, _jwt, eid), getQrBaseUrl(_school, _jwt)];

    Promise.all(promises).then((results) => {
      let result = results[0];

      setActivityDate(result.data);
      const encrypted = encryptActivitySignup(ACTIVITY_QR_KEY, eid);
      setSearchPerformed(true);

      const baseUrl = results[1];
      setQrUrl(baseUrl + `/student/ad/signup-attend/${encrypted}`)
      setShowProgress(false);
    });
  };


  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={512} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Signup AND Attendance QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <Alert severity="error">
            This QR code allows students to both sign up and mark themselves as present in a single step.  It should ONLY be used if the student
            came to your activity after the cutoff time.
          </Alert>
          <HeaderText text={_activityDate.name} />
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell variant="head">Date</TableCell>
                <TableCell>
                  {dayjs(_activityDate.date).format("MM/DD/YYYY")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Period</TableCell>
                <TableCell>{_activityDate.periodName}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Location Name</TableCell>
                <TableCell>{_activityDate.locationName}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Main Proctor</TableCell>
                <TableCell>
                  {_activityDate.first_name} {_activityDate.last_name}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p>
            <a href={_qrUrl}>Link</a>
          </p>
        </Box>
      </Container>
    </>
  );
};

export default ActivitySignupAttendQr;
